import { axios, Response } from '../index'

type Body = {
  title: string
  responsibleForTheDemandId?: string
  isDone: boolean
}

const updateChecklistItem = (
  checklistItemId: string,
  body: Body,
  taskId: string,
  checklistId: string
): Response<null> => {
  return axios.put(
    `/v1/tasks/${taskId}/checklists/${checklistId}/checklist-items/${checklistItemId}`,
    body
  )
}

export default updateChecklistItem
